import { LuminorInitializeResponseDTO } from '@app/domain/api/LuminorInitializeResponseDTO';

export async function submitLuminorAuthForm(
    initializeData: LuminorInitializeResponseDTO,
    actionUrl: string,
): Promise<void> {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = actionUrl;
    form.style.display = 'none';

    Object.entries(initializeData).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
